import { render } from "./Programs.vue?vue&type=template&id=49309be7"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__